import React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import {delay} from '../../../helpers/utils'

export default function QuestionValue(props) {
  const {context, className, question} = props
  const {translate} = context
  const [value, setValue] = React.useState(0)

  function handleBlur (e) {
    const cleared = value === ''
    const points = cleared ? 0 : parseInt(value)
    props.updateProperties && props.updateProperties({
      id: question.id,
      value: points,
      properties: {cleared}
    }, {
      value: {$set: points},
      properties: {cleared: {$set: cleared}}
    }
    )
  }

  function handleChange (e) {
    const value = e.target.value == '' ? '' : parseInt(e.target.value)
    setValue(value)
  }

  React.useEffect(() => {
    const isNewValue = question.value && value != question.value
    const isCleared = question.properties && question.properties.cleared
    if (isNewValue || isCleared) {
      const points = question.properties.cleared ? '' : question.value 
      setValue(points)
    }
  }, [question.value])

  return (
  <Box className={className}>
    <Box className="valueLabel">
      {translate('value')}:
    </Box>
    <TextField
      className="valueInput"
      InputProps={{inputProps: {min: 0, max: 1000}}}
      value={value}
      type="number"
      onChange={handleChange}
      onBlur={handleBlur}
    />
  </Box>
  )
}
